import { FETCH_TRACK_AND_TRACE, RECEIVE_TRACK_AND_TRACE, FAILED_TRACK_AND_TRACE } 
from '../actions/aTransporter-TrackAndTrace.jsx'

const defaultTrackAndTraceListState = {
    trackAndTraceListData: [],
    loading: "loading",
}

export function fetchTrackAndTraceList(state = defaultTrackAndTraceListState, action){
    switch (action.type) {
        case FETCH_TRACK_AND_TRACE:
            return ({trackAndTraceListData: [], loading: "loading"})
        case RECEIVE_TRACK_AND_TRACE:
            return Object.assign({}, state, {trackAndTraceListData: action.payload, loading: "success"})
        case FAILED_TRACK_AND_TRACE:
            return ({trackAndTraceListData: [], loading: "failed"})
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/redTransporter-TrackAndTrace.jsx